import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchProductsGroupApi,
  fetchProductsGroupByIdApi,
  createProductsGroupApi,
  updateProductsGroupApi,
  filterProductGroupApi,
} from "../../../api/endpoint";

function* getProductsGroupSaga(action) {
  try {
    const _api = yield call(fetchProductsGroupApi, action.payload);
    yield put(actions.setProductsGroup(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* getProductsGroupByIdSaga(action) {
  try {
    const _api = yield call(fetchProductsGroupByIdApi, action.payload);
    yield put(actions.setProductsGroupById(..._api.data.results));

    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

function* createProductsGroupSaga(action) {
  try {
    const _api = yield call(createProductsGroupApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setUpdatedProductGroup(action.payload));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "Product Group Successfully Updated",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setRedirect(true));
    yield put(
      commonActions.setAlert({
        message: "Something went wrong",
        alertType: "error",
        alertStatus: true,
      })
    );
  }
}

function* updateProductsGroupSaga(action) {
  try {
    const _api = yield call(updateProductsGroupApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setUpdatedProductGroup(action.payload));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "Product Group Successfully Updated",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setRedirect(true));
    yield put(
      commonActions.setAlert({
        alertStatus: true,
        message: "Something went wrong",
        alertType: "error",
      })
    );
  }
}

function* filterProductsGroupSaga(action) {
  try {
    const _api = yield call(filterProductGroupApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilteredResults(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* watchProductsGroupSaga() {
  yield all([
    takeEvery(actionTypes.GET_PRODUCTS_GROUP, getProductsGroupSaga),
    takeEvery(actionTypes.GET_PRODUCTS_GROUP_ID, getProductsGroupByIdSaga),
    takeEvery(actionTypes.CREATE_PRODUCT_GROUP, createProductsGroupSaga),
    takeEvery(actionTypes.UPDATE_PRODUCT_GROUP, updateProductsGroupSaga),
    takeEvery(actionTypes.GET_FILTERED_RESULTS, filterProductsGroupSaga),
  ]);
}
